import { render, staticRenderFns } from "./CodingQuestion.vue?vue&type=template&id=6ad476c4&scoped=true&"
import script from "./CodingQuestion.vue?vue&type=script&lang=js&"
export * from "./CodingQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CodingQuestion.vue?vue&type=style&index=0&id=6ad476c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad476c4",
  null
  
)

export default component.exports